<template>
  <base-container class="p-6 flex flex-col gap-6">
    <DisruptionPartners />
    <div class="flex flex-col gap-4">
      <h1>
        Tous les outils pour combattre les ruptures
      </h1>
      <BaseCard>
        <BaseCardBody>
          <product-search-bar />
          <div class="flex flex-col gap-4">
            <HealthcenterWarehouses />
            <HealthcenterGroup />
          </div>
        </BaseCardBody>
      </BaseCard>
      <router-link :to="{name: 'disruption-logistics.direct-availability-sources'}">
        <PatientAdministrationHomeCard
          class="menu-card"
          title="Disponibilités vente directe"
          icon-name="mdi-package-variant"
          subtitle="Visualisez la disponibilité des produits en vente directe"
        />
      </router-link>
      <router-link :to="{name: 'disruption-logistics.disruptions'}">
        <PatientAdministrationHomeCard
          class="menu-card"
          title="Retours de dispo"
          icon-name="mdi-bell-outline"
          subtitle="Soyez notifié lorsqu'un produit en rupture est à nouveau disponible"
        />
      </router-link>
      <router-link :to="{name: 'disruption-logistics.disruption-alerts'}">
        <PatientAdministrationHomeCard
          class="menu-card"
          title="Offres de dépannage"
          icon-name="mdi-ambulance"
          subtitle="Recevez des offres de dépannage de vos partenaires lorsque vous êtes en rupture"
        />
      </router-link>
    </div>
    <div class="flex-1" />
    <div class="flex gap-3 justify-center">
      <div class="flex justify-center items-center max-w-2xl text-center">
        <div class="hidden lg:flex flex-col items-center text-center">
          <span class="text-3xl">
            😉
          </span>
          <p
            class="text-sm font-bold"
            style="transform: rotate(-10deg)"
          >
            Hey pssst!
          </p>
        </div>
        <p class="text-primary flex-1">
          <strong>Gagnez 1 mois d'utilisation gratuite</strong> pour chaque pharmacie parrainée avec
          votre code <span class="bg-white px-2">{{ sponsorshipCouponCode }}</span>{{ ' ' }}
          <router-link
            :to="{name: 'sponsorship'}"
            class="underline"
          >
            Comment ça marche ?
          </router-link>
        </p>
      </div>
    </div>
  </base-container>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import BaseContainer from "@/core/components/base/BaseContainer.vue";
import ProductSearchBar from "@/disruption-logistics/components/product-search-bar/ProductSearchBar.vue";
import {mapState} from "pinia";
import {useSystemStore} from "@/stores/system.store";
import DisruptionPartners from "@/disruption-logistics/components/disruption-partners/DisruptionPartners.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import HealthcenterWarehouses from "@/disruption-logistics/components/home/HealthcenterWarehouses.vue";
import HealthcenterGroup from "@/disruption-logistics/components/home/HealthcenterGroup.vue";
import PatientAdministrationHomeCard from "@/patient-administration/components/PatientAdministrationHomeCard.vue";

export default defineComponent({
    name: "DisruptionLogisticsHomeView",
    components: {
        PatientAdministrationHomeCard,
        HealthcenterGroup,
        HealthcenterWarehouses,
        BaseCardBody,
        BaseCard,
        DisruptionPartners, ProductSearchBar, BaseContainer},
    computed: {
        ...mapState(useSystemStore, ['environment']),
        /**
     * Get the partnership coupon code
     */
        sponsorshipCouponCode(): string {
            return this.environment?.entity.cip ?? '';
        }
    }
});
</script>

<style scoped>
.menu-card:deep(.v-icon) {
    @apply !text-primary;
}
</style>
